export const TIMELINE_COLOR = {
    WHITE: 'white',
    GREY: 'grey',
    GREEN: 'green',
    BLUE: 'blue',
    YELLOW: 'yellow',
    ORANGE: 'orange',
};
export const TIMELINE_TEXT_ALIGNMENT = {
    CENTER: 'center',
    LEFT: 'left',
    RIGHT: 'right',
};
export const EXPAND_ACCORDION = 'cta: accordion expand';
export const COLLAPSE_ACCORDION = 'cta: accordion collapse';
export const THRESHOLD_PERCENT_WHEN_VISIBLE = 0.8;
export const ACCORDION_MODE_SCROLL = 'scroll';
export const ACCORDION_MODE_DEFAULT = 'default';
export const ACCORDION_TITLE_HEIGHT = 45;
